import React, { useEffect, useState } from 'react';
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  Typography,
  Chip,
  Stack,
} from '@mui/material';
import dayjs from 'dayjs';
import { LEAVE_TYPE_COLORS, LEAVE_TYPE_LABELS } from '../../containers/attendancemng/AttendMngContainer';

const LeaveRequestActionDialog = ({ open, mode, row, onClose, onConfirm }) => {
  const [comment, setComment] = useState('');

  useEffect(() => {
    if (open) {
      setComment('');
    }
  }, [open, mode, row]);

  const isReject = mode === 'REJECT';

  const handleConfirm = () => {
    if (isReject && !comment.trim()) {
      return;
    }
    onConfirm(comment.trim());
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{isReject ? '휴가 신청 반려' : '휴가 신청 승인'}</DialogTitle>
      <DialogContent dividers>
        {row && (
          <Stack spacing={2} sx={{ pt: 1 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography variant="caption" color="text.secondary">신청자</Typography>
                <Typography variant="body2">{row.usrNm} {row.dptNm ? `(${row.dptNm})` : ''}</Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="caption" color="text.secondary">구분</Typography>
                <Box sx={{ mt: 0.5 }}>
                  <Chip
                    label={LEAVE_TYPE_LABELS[row.leaveTyp] || row.leaveTyp}
                    color={LEAVE_TYPE_COLORS[row.leaveTyp] || 'default'}
                    size="small"
                    variant="outlined"
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="caption" color="text.secondary">기간</Typography>
                <Typography variant="body2">
                  {dayjs(row.leaveDtSt).format('YYYY-MM-DD')} ~ {dayjs(row.leaveDtEd).format('YYYY-MM-DD')}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="caption" color="text.secondary">일수</Typography>
                <Typography variant="body2">{row.leaveDays}일</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="caption" color="text.secondary">사유</Typography>
                <Typography variant="body2">{row.rmk || '-'}</Typography>
              </Grid>
            </Grid>

            <TextField
              fullWidth
              multiline
              minRows={3}
              size="small"
              label={isReject ? '반려 사유 *' : '의견'}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              error={isReject && !comment.trim()}
              helperText={isReject && !comment.trim() ? '반려 시 사유를 입력하세요.' : ' '}
            />
          </Stack>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">취소</Button>
        <Button onClick={handleConfirm} variant="contained" color={isReject ? 'error' : 'success'}>
          {isReject ? '반려' : '승인'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LeaveRequestActionDialog;
